import productAPI from '@/api/product-api.js'

export default {
  state: {
    productCategories: [],
    allProducts: [],
    productDetails: {}
  },
  getters: {
    getProductCategories (state) {
      return state.productCategories
    },
    getAllProducts (state) {
      return state.allProducts
    },
    getProductDetails (state) {
      return state.productDetails
    }
  },
  mutations: {
    setProductCategories (state, value) {
      state.productCategories = value
    },
    setAllProducts (state, value) {
      state.allProducts = value
    },
    setProductDetails (state, value) {
      state.productDetails = value
    }
  },
  actions: {
    GET_ALL_CATEGORIES ({ commit }, { query, success, fail }) {
      commit('setProductCategories', [])
      productAPI.getAllCategories(query).then(res => {
        const resBody = res.body
        if (resBody && resBody.success && resBody.errorCode === null) {
          const activeCategories = resBody.content.filter(({ active, totalProduct }) => active && totalProduct > 0)
          commit('setProductCategories', activeCategories)
          success && success(activeCategories)
        } else {
          fail && fail(res)
        }
      },
      err => {
        fail && fail(err)
      })
    },
    GET_ALL_PRODUCTS ({ commit }, { query, success, fail }) {
      commit('setAllProducts', [])
      productAPI.getAllProducts(query).then(res => {
        const resBody = res.body
        if (resBody && resBody.success && resBody.errorCode === null) {
          const enabledProducts = resBody.content.map(product => {
            const validProductCondition = product.enableProduct
                && product.productVariantTypeList?.length
                && product.productVariantTypeList.some(item => item.enableProduct)
            if (validProductCondition) {
              const variants = product.productVariant
              const isColorVariantAvailable = variants?.color?.length
              const isOtherVariantAvailable = variants && Object.keys(variants).length
              return {
                productId: product.productId,
                productImageUrl: product.productImageUrl,
                isColorVariantAvailable: !!isColorVariantAvailable,
                isOtherVariantAvailable: !!isOtherVariantAvailable,
                productName: product.productName,
                productVariantTypeList: product.productVariantTypeList
              }
            }
          })
          const emptyRemovedProducts = enabledProducts.filter(Boolean)
          commit('setAllProducts', emptyRemovedProducts)
          success && success(emptyRemovedProducts)
        }
        else {
          fail && fail(res)
        }
      },
      err => {
        fail && fail(err)
      })
    },
    GET_PRODUCT_DETAILS ({ commit }, { query, success, fail }) {
      this.productDetails = {}
      commit('setProductDetails', {})
      productAPI.getProductDetails(query).then(res => {
        const resBody = res.body
        const isSuccessResponse = resBody && resBody.success && !resBody.errorCode
            && resBody.value.enableProduct
        if (isSuccessResponse) {
          const value = resBody.value
          const productVariant = value.productVariant
          if (productVariant) {
            const enabledProductVariant = Object.fromEntries(Object.entries(productVariant).map(spec => [spec[0], []]))
            value.productVariantTypeList.forEach(variant => {
              if (variant.enableProduct) {
                for (const [key, value] of Object.entries(variant.productVariantDetail)) {
                  enabledProductVariant[key].push(value)
                }
              }
            })
            const duplicatesRemoved = Object.fromEntries(Object.entries(enabledProductVariant).map(entry => [entry[0], [...new Set(entry[1])]]))
            commit('setProductDetails', {
              ...value,
              productVariant: duplicatesRemoved
            })
          } else {
            commit('setProductDetails', value)
          }
          success && success(res)
        } else {
          fail && fail(res)
        }
      },
      err => {
        fail && fail(err)
      })
    }
  },
  namespaced: true
}
